<template>
	<v-row>
		<v-col>
			<v-text-field 
			prepend-icon="mdi-slash-forward"
			v-model="url" 
			:error-messages="urlError" 
			:label="label"
			:append-icon="icon"
			:color="color"
			hint="This field creates a new path for this site where users can access this survey. It should not contain and slashes or special characters" persistent-hint
			v-on:blur="save"
			></v-text-field>
		</v-col>
		<v-col cols="2">
			<a class="mt-5" target="blank" :href="path" style="font-size: 0.78em">{{path}}</a>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: "NamedUrlField",
		props: {
			id: {type: String },
			type: {type: String },
			label: {type: String },
			unique: {type: Boolean, default: true},

		},
		data: () => {
			return {
				url: '', 
				urlError: false, 
				existingUrl: false, 
				existingUrls: [], 
				saved: false
			}
		},
		computed:{
			path() {
				return window.location.origin + "/" + this.url;
			},
			icon(){
				if( this.urlError ){
					return "mdi-alert"
				}
				if( this.saved ){
					return "mdi-check-circle"
				}
				else{
					return ""
				}
			},
			color(){
				if( this.urlError ){
					return "red"
				}
				if( this.saved ){
					return "green"
				}
				else{
					return ""
				}
			}
		},
		methods:{			
			checkExists(){
				const self = this;
				this.saved = false;
				if( self.url == self.existingUrl ){
					self.urlError = false;
					return;
				}
				if( self.url ){ 
					self.$store.dispatch("getDoc", {
						doc: "namedUrls/" + self.url 
					}).then( (doc) => {
						if( doc ){
							if( doc.id == self.id ){
								self.urlError = false;
							}
							else{
								self.urlError = ["URL in use"];
							}
						}
						else{
							self.urlError = false;
						}
					})	
				}

			},
			save(){
				const self = this
				if( self.urlError ){
					return;
				}
				if( self.url ){

					self.$store.dispatch("updateDoc", {
						doc: "namedUrls/" + self.url, 
						data: {type: self.type , objectId: self.id }, 
						action: "set"
					}).then( () => {					
						this.saved = true
						if( self.existingUrl && self.existingUrl !== self.url ){
							self.$store.dispatch("updateDoc", {
								doc: "namedUrls/" + self.existingUrl, 
								action: "delete"
							})
						}			
					})
				}
			}
		},
		watch:{
			url(){
				this.url = this.url.split("/").join("");
				this.checkExists();
			}
		},
		created(){
			const self = this;
			if( !self.type || !self.id ){ return; }
			self.$store.dispatch("fetchNamedUrl", {objectId: self.id, type: self.type} ).then( url => {
				if( self.unique ){
					self.existingUrl = url;
					self.url = url;
				}
				else{
					self.existingUrls.push(url);
				}
				
			})
		
		}
	}
</script>